import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/StatusBadge";

export default function Notifications() {
  const [d, setD] = useState(null);
  const load = () => api.get("/notifications").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  const readAll = async () => { await api.post("/notifications/read-all"); load(); };
  const open = (n) => !n.read && api.post(`/notifications/${n.notification_id}/read`);
  return (
    <div>
      <PageHeader eyebrow="Inbox" title="Notifications" testid="notifications-title">
        <Button variant="outline" size="sm" onClick={readAll} data-testid="notifications-read-all">Mark all read</Button>
      </PageHeader>
      <div className="rounded-lg border border-slate-200 bg-white shadow-sm divide-y divide-slate-100" data-testid="notifications-list">
        {d?.items.length === 0 && <p className="p-8 text-center text-sm text-slate-500">You're all caught up.</p>}
        {d?.items.map((n) => (
          <Link key={n.notification_id} to={n.record_id ? `/records/${n.record_id}` : n.office && n.office !== "main" ? `/committees/${n.office}?tab=reports` : "#"} onClick={() => open(n)} data-testid={`notification-${n.notification_id}`}
            className={`flex gap-3 px-4 py-3 hover:bg-slate-50 transition-colors ${n.read ? "" : "bg-blue-50/40"}`}>
            <span className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${n.read ? "bg-slate-200" : "bg-blue-600"}`} />
            <div className="min-w-0 flex-1">
              <div className="text-sm font-medium text-slate-900">{n.title}</div>
              <div className="text-sm text-slate-600 truncate">{n.message}</div>
              <div className="text-[11px] text-slate-400 mt-0.5">{fmtDate(n.created_at)} · {Object.entries(n.channels || {}).map(([c, s]) => `${c.replace("_", "-")}: ${s}`).join(" · ")}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
